


























import './scss/BaseCheckbox.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'BaseCheckbox',
})
export default class BaseCheckbox extends Vue {
    @Prop({ default: false }) checked!: boolean;
    @Prop({ default: 'circle' }) shape!: 'circle';
    @Prop({ default: false }) disabled!: boolean;

    emitChange() {
        this.$emit('change');
    }
}
